import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { LabelText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuCategoryBadge = (props: Props) => {
  const { children, sizeMatch = ['12'] } = props;

  return (
    <View style={styles.container}>
      <LabelText sizeMatch={sizeMatch}>{children}</LabelText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.LIME,
    borderRadius: theme.radius.medium,
    paddingVertical: 2,
    paddingHorizontal: theme.spacing['2'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  children: string;
  sizeMatch?: ComponentProps<typeof LabelText>['sizeMatch'];
};
